import { Component, Input,  OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder,  FormControl,  FormGroup,  Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';

import { LoaderService } from 'app/shared/services/loader.service';

import * as moment from 'moment';
import { Moment } from 'moment';

import { IDatePickerDirectiveConfig } from 'ng2-date-picker';

import { finalize } from 'rxjs/operators';

import { ToastrService } from 'ngx-toastr';

import { Observable } from 'rxjs';

import { DataTableColumn, DataTableComponent } from 'app/shared/data-table/data-table.component';
import { SortDirection } from 'app/shared/sort-direction';
import { SearchObjectResult } from 'app/shared/search-object-result.model';

import { DFManagementSearchFilter } from '../shared/df-management-search-filter.model';
import { DFAsset, DFCarrier, DFCountry, DFCountryCarrierList } from '../shared/df-management.coutry.model';
import { DfManagementService } from '../shared/df-management.service';
import { DFAssetCharges, DFContract, DFFieldValidate, DFVariableCharges, MasterData } from '../shared/df-master-data.model';
import { ErrorHandlerService } from 'app/shared/services/error-handler.service';
import { DFUploadMasterData } from '../shared/file-upload-master-data.model';
import { Base64ToBlob } from '../shared/utiles/base64Toblob';
import { NotificationsService } from '../shared/notifications.service';

@Component({
  selector: 'app-df-master-data-list',
  templateUrl: './df-master-data-list.component.html',
  styleUrls: ['./df-master-data-list.component.scss']
})
export class DfMasterDataListComponent implements OnInit {
  public acceptedFileExtensions = ['.xlsx', '.csv'];
  isShowFile = false;
  dedicatedFleetMasterDataForm: FormGroup;
  searchForm: FormGroup;
  isVisible = false;
  dateErrorMsg = false;
  countryData: DFCountryCarrierList[] = [];
  carriers: DFCountryCarrierList[] = [];
  assets: DFAsset[] = [];
  config: IDatePickerDirectiveConfig;
  searchText = '';
  editMasterData: DFContract;
  selectCountry: string;
  selectCarrierID: string;
  selectAssetID: string;
  isPopupModel = false;
  isDownReportSuccessPopupModel = false;
  isPopupDownloadModel = false;
  isPopupErrorModel = false;
  isFetchButtonDisabled = true;
  isButtonDisabled = true;
  isEditButtonDisabled = true;
  failedReport: string;
  countryCode: string;
  country: string;
  @Input()
  maxDate: Moment;
  @Input()
  minDate: Moment;
  countryList: DFCountry;
  assetContent: string;
  verificationResult: DFUploadMasterData[];
  fixedFrequencyCharge: string;
  fixedFrequencyTruckRent: DataTableColumn;
  blob = new  Base64ToBlob;
  isPopupVisible!: Observable<boolean>;
  filters: DFManagementSearchFilter = {
    carrierCodeList: null,
    carrierCode: null,
    assetId: null,
    search: null
  };
  validate: DFFieldValidate = {
    contractStartDate: false,
    contractEndDate: false,
    dfDistance: false,
    contractedTruckRentCharges: false,
    removeBtn: false,
    submitBtn: false
  }
  @ViewChild('carrierCodeColumn', { static: true })
  carrierCodeColumn: TemplateRef<any>;

  @ViewChild('assetIdColumn', { static: true })
  assetIdColumn: TemplateRef<any>;

  @ViewChild('equipmentTypeColumn', { static: true })
  equipmentTypeColumn: TemplateRef<any>;

  @ViewChild('contractStartDateColumn', { static: true })
  contractStartDateColumn: TemplateRef<any>;

  @ViewChild('contractEndDateColumn', { static: true })
  contractEndDateColumn: TemplateRef<any>;

  @ViewChild('dfDistanceColumn', { static: true })
  dfDistanceColumn: TemplateRef<any>;

  @ViewChild('rentChargesColumn', { static: true })
  rentChargesColumn: TemplateRef<any>;

  @ViewChild('actionsColumn', { static: true })
  actionsColumn: TemplateRef<any>;

  @ViewChild(DataTableComponent, { static : true })
  masterDataListTable: DataTableComponent;
  columns: DataTableColumn[] = [];
  sortColumn: DataTableColumn;
  SortDirection = SortDirection.ASC;
  loadPage: (...config) => Observable<SearchObjectResult<MasterData>> = null;

  constructor(private fb: FormBuilder,
    private dfManagementService: DfManagementService,
    private toastr: ToastrService,
    private loader: LoaderService,
    private translate: TranslateService,
    private errorHandlerService: ErrorHandlerService,
    private notificationService: NotificationsService
    ) {}

  ngOnInit() {
    this.dedicatedFleetMasterDataForm = this.fb.group({
      carrierId: [''],
      assetId: [''],
      contractStartDate: ['', [Validators.required]],
      contractEndDate: ['', [Validators.required]],
      dfDistance: ['', [Validators.required]],
      contractedTruckRentCharges: ['', [Validators.required]],
      amount: this.fb.array([]),
    });
    this.searchForm = this.fb.group( {
      assetId: [null],
      carrierId: [null],
      country: [null],
    });
    this.config = {
      appendTo: 'body',
      drops: 'down',
      firstDayOfWeek: 'mo',
      format: 'YYYY-MM-DD',
      max: this.maxDate,
      min: this.minDate,
      disableKeypress: false,
      unSelectOnClick: true,
      isDayDisabledCallback: (date: Moment) => {
        const cStartDate = this.editMasterData['contractStartDate'] || undefined;
        const cEndDate = this.editMasterData['contractEndDate'] || undefined;
        const today = new Date();
        let res = false;
        if (cStartDate && cEndDate && (moment(cStartDate).utc().format('YYYY-MM-DD') < moment(today).utc().format('YYYY-MM-DD')
        && (moment(date.toString()).utc().format('YYYY-MM-DD') < moment(today.setDate(today.getDate() - 1 )).utc().format('YYYY-MM-DD')))) {
          res = true;
        }
        return res;
      },
    }
    this.dedicatedFleetMasterDataForm.controls['contractEndDate'].valueChanges.subscribe(res => {
      if (moment(res).utc().isBefore(moment(this.dedicatedFleetMasterDataForm.value.contractStartDate).utc())) {
        this.dateErrorMsg = true;
      } else {
        this.dateErrorMsg = false;
      }
    })
    this.getDFCountryResponse();
    this.displayColumns();
    this.isPopupVisible = this.notificationService.isPopupVisible;
  }

  displayColumns() {
    switch (this.fixedFrequencyCharge) {
      case 'Daily':
        this.fixedFrequencyTruckRent = {
          name: 'rentCharges',
          displayed: true,
          translationKey: 'df-management.table.contracted-truck-rent-charges',
          template: this.rentChargesColumn,
          sortable: false,
          alignCenter: true,
        }
        break;
      case 'Weekly':
        this.fixedFrequencyTruckRent = {
          name: 'rentCharges',
          displayed: true,
          translationKey: 'df-management.table.weekly-truck-rent',
          template: this.rentChargesColumn,
          sortable: false,
          alignCenter: true,
        }
        break;
      case 'Monthly':
        this.fixedFrequencyTruckRent = {
          name: 'rentCharges',
          displayed: true,
          translationKey: 'df-management.table.monthly-truck-rent',
          template: this.rentChargesColumn,
          sortable: false,
          alignCenter: true,
        }
        break;
      default:
        this.fixedFrequencyTruckRent = {
          name: 'rentCharges',
          displayed: true,
          translationKey: 'df-management.table.contracted-truck-rent-charges',
          template: this.rentChargesColumn,
          sortable: false,
          alignCenter: true,
        }
        break;
    }
    const assetId = {
      name: 'assetId',
      displayed: true,
      translationKey: 'df-management.table.asset-id',
      template: this.assetIdColumn,
      sortable: false,
      alignCenter: true,
    };
    this.columns = [
      {
        name: 'carrierCode',
        displayed: true,
        translationKey: 'df-management.table.carrier-id',
        template: this.carrierCodeColumn,
        sortable: false,
        alignCenter: true,
      },
      assetId,
      {
        name: 'assetType',
        displayed: true,
        translationKey: 'df-management.table.equipment-type',
        template: this.equipmentTypeColumn,
        sortable: false,
        alignCenter: true,
      },
      {
        name: 'contractStartDate',
        displayed: true,
        translationKey: 'df-management.table.contract-start-date',
        template: this.contractStartDateColumn,
        sortable: true,
        alignRight: false,
        alignCenter: true,
      }, {
        name: 'contractEndDate',
        displayed: true,
        translationKey: 'df-management.table.contract-end-date',
        template: this.contractEndDateColumn,
        sortable: false,
        alignCenter: true,
      },
      {
        name: 'distanceTravel',
        displayed: true,
        translationKey: 'df-management.table.df-distance',
        template: this.dfDistanceColumn,
        sortable: false,
        alignCenter: true,
      },
      this.fixedFrequencyTruckRent
      ,
      {
        name: 'actions',
        displayed: true,
        translationKey: 'df-management.table.actions',
        template: this.actionsColumn,
        sortable: false,
        alignCenter: true,
      },
    ];
    this.sortColumn = this.columns.find((col: DataTableColumn) => col.name === 'contractStartDate');
  }

  setExistingHeaders(chargesList: DFVariableCharges[]): FormArray {
    const formArray = new FormArray([]);
    chargesList?.forEach((s, i) => {
      formArray.push(
        this.fb.group({
          id: new FormControl(s.id),
          charge_code: new FormControl(s.charge_code),
          charge_amount: new FormControl(s.charge_amount),
          charge_type: new FormControl(s.charge_type)
        })
      );
    });
    return formArray;
  }

  resetSearchData() {
    if (this.countryCode) {
      this.searchForm.controls['carrierId'].reset();
      this.searchForm.controls['assetId'].reset();
      this.searchText = '';
      this.filters.assetId = null;
      this.filters.carrierCode = null;
      this.assets = [];
      this.applyForm('fleetManagement')
    }

  }

  getDFCountryResponse() {
    this.loader.startLoad();
    let countryResponse;
   this.dfManagementService.getAllcountry()
    .pipe(finalize(() => this.loader.stopLoad()))
    .subscribe((country: SearchObjectResult<DFCountryCarrierList>) => {
      this.translatePlaceholders();
      const foundIndex = country.results.findIndex((i: any) => {
        if (i.countryCode !== 'USA') {
        countryResponse = this.removeAt(foundIndex, i);
        this.countryData.push(countryResponse);
        this.countryData.sort((a, b) => (a.countryCode > b.countryCode) ? 1 : -1)
        }
      });
    }, (error: HttpErrorResponse) => {
      this.translatePlaceholders();
      this.toastr.error(error['error_message'] || this.translate.instant('df-management.table.error-fetching-country'));
    });
  }

  removeAt(index: number, arr: DFCountryCarrierList[]) {
    if (index > -1) {
      const len = arr.length - 1;
      return arr.slice(0, index - len - 1).concat(arr.slice(index + 1, len + 1));
    }
    return arr;
  }

  translatePlaceholders() {
     this.selectCountry = this.translate.instant('df-management.filters.placeholder.select-country');
     this.selectCarrierID = this.translate.instant('df-management.filters.placeholder.select-carrierId');
     this.selectAssetID = this.translate.instant('df-management.filters.placeholder.select-asset-id');
  }

  updateCountry(country: DFCountry) {
    this.countryList = country;
    this.loader.startLoad();
    this.filters.carrierCode = null;
    this.filters.carrierCodeList = null;
    this.searchText = '';
    this.filters.assetId = null;
    this.searchForm.controls['carrierId'].reset();
    this.searchForm.controls['assetId'].reset();
    if (country != null) {
      this.country = country?.country;
      this.countryCode = country?.countryCode;
     this.dfManagementService.getAllCarrierIdBasedOnCountry(country?.countryCode)
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe((carriers: DFCountryCarrierList[]) => {
        this.fixedFrequencyCharge = carriers['results'].fixed_charge_frequency;
        this.displayColumns();
        if (this.assetContent === 'blueYounder' && this.countryCode) {
          this.isEditButtonDisabled = false;
          this.assetContent = null;
        } else {
          this.isFetchButtonDisabled = false;
          this.isButtonDisabled = true;
        }
        this.isEditButtonDisabled = true;
        if (carriers['status_code'] === '1') {
          if (carriers['results']['carrier'] === null) {
            this.carriers = [];
            this.assets = [];
            const tempFilters = this.filters
            delete tempFilters['carrierCodeList'];
            this.filters = tempFilters
            this.toastr.error(this.translate.instant('df-management.table.no-carriers-found'));
          } else {
            this.carriers = carriers['results']['carrier'];
            this.carriers.sort((a, b) => (a.carrier > b.carrier) ? 1 : -1)
            this.assets = [];
            this.selectAllForDropdownItems(this.carriers);
          }
        }
        if (carriers['error_code'] === '-10') {
          this.carriers = [];
          this.assets = [];
          this.toastr.error(carriers['error_message']);
        }
      }, (error: HttpErrorResponse) => {
        this.toastr.error(error['error_message'] || this.translate.instant('df-management.table.error-fetching-carriers'));
      })
    } else {
      this.filters.carrierCode = null;
      this.carriers = [];
      this.assets = [];
      this.countryCode = null;
      this.loader.stopLoad()
      this.isFetchButtonDisabled = true;
      this.isEditButtonDisabled = true;
      this.isButtonDisabled = true;
      this.assetContent = '';
      this.searchForm.controls['country'].reset();
      this.filters.carrierCodeList = null;
    }
  }

  updateCarrierId(carrier: DFCarrier[]) {
    this.filters.assetId = null;
    if (carrier != null) {
      const carrierList = [];
      const assetList = [];
      carrier?.forEach(carriers => {
      carrierList.push(carriers.carrier_code);
      carriers.asset.filter(assets => {
        assetList.push(assets);
      });
      })
      this.filters.carrierCodeList = carrierList.join(',');
      this.assets = assetList;
      this.assets.sort((a, b) => (a.asset_id > b.asset_id) ? 1 : -1)
      this.searchForm.controls['assetId'].reset();
    } else {
      this.filters.carrierCodeList = null;
      this.filters.assetId = null;
      this.assets = [];
      this.searchForm.controls['assetId'].reset();
    }
  }

  updateAsset(asset: DFAsset) {
    if (asset != null) {
      this.filters.assetId = asset?.asset_id;
    } else {
      this.filters.assetId = null;
    }
  }

  onEditClick(item: DFContract) {
    this.isVisible = !this.isVisible;
    this.editMasterData = item;
    this.dedicatedFleetMasterDataForm.controls['assetId'].patchValue(item.assetId);
    this.dedicatedFleetMasterDataForm.controls['carrierId'].patchValue(item.carrierCode);
    if (this.editMasterData['contractStartDate'] !== null) {
      this.dedicatedFleetMasterDataForm.controls['contractStartDate'].patchValue(moment(item.contractStartDate).utc().format('YYYY-MM-DD'));
    } else {
      this.dedicatedFleetMasterDataForm.controls['contractStartDate'].patchValue(item.contractStartDate);
    }
    if (this.editMasterData['contractEndDate'] !== null) {
      this.dedicatedFleetMasterDataForm.controls['contractEndDate'].patchValue(moment(item.contractEndDate).utc().format('YYYY-MM-DD'));

    } else {
      this.dedicatedFleetMasterDataForm.controls['contractEndDate'].patchValue(item.contractEndDate);
    }
    this.dedicatedFleetMasterDataForm.controls['dfDistance'].patchValue(item.distanceTravel);
    this.dedicatedFleetMasterDataForm.controls['contractedTruckRentCharges'].patchValue(item.rentCharges);
    if (item.assetCharges?.length) {
      this.dedicatedFleetMasterDataForm.setControl(
        'amount',
        this.setExistingHeaders(item.assetCharges)
      );
    }
    const now = new Date();
    let date = JSON.stringify(now)
      date = date.slice(1, 11)
    if (item.contractEndDate && moment(item.contractEndDate).utc().format('YYYY-MM-DD') <
     moment(now.setDate(now.getDate() - 1)).utc().format('YYYY-MM-DD')) {
      this.setFieldValidation(true, true, true, true, true, true);
      this.validateEdit(item);
    } else if (item.contractStartDate && moment(item.contractStartDate).utc().format('YYYY-MM-DD') === moment(date).utc().format('YYYY-MM-DD')) {
      this.setFieldValidation(true, false, true, true, false, false);
      this.validateEdit(item);
    } else if (item.contractStartDate && item.contractEndDate &&
       (moment(item.contractStartDate).utc().format('YYYY-MM-DD') < moment(date).utc().format('YYYY-MM-DD')
      && !(moment(item.contractEndDate).utc().format('YYYY-MM-DD') < moment(now.setDate(now.getDate() - 1)).utc().format('YYYY-MM-DD')))) {
      this.setFieldValidation(true, false, true, true, true, false);
      this.validateEdit(item);
    } else {
      this.setFieldValidation(false, false, false, false, false, false);
    }
    this.dateErrorMsg = false;
  }

  setFieldValidation(contractStartDate: boolean, contractEndDate: boolean, dfDistance: boolean, contractedTruckRentCharges: boolean,
    removeBtn: boolean, submitBtn: boolean) {
    this.validate = {
      contractStartDate: contractStartDate,
      contractEndDate: contractEndDate,
      dfDistance: dfDistance,
      contractedTruckRentCharges: contractedTruckRentCharges,
      removeBtn: removeBtn,
      submitBtn: submitBtn
    }
  }

  validateEdit(item: DFContract) {
    item.assetCharges?.forEach((charge: DFAssetCharges) => {
      this.validate[charge.charge_code] = charge.charge_amount;
    });
  }

  onCloseClick() {
    this.isVisible = false;
    this.resetDfMasterData();
  }

 applyForm(assets: string) {
  this.assetContent = assets;
  this.isButtonDisabled = true;
  this.isFetchButtonDisabled = true;
  this.isEditButtonDisabled = true;
  if (assets === 'blueYounder') {
    this.updateCountry(this.countryList);
  }
  this.filters.search = this.searchText;
  const tempFilters = this.filters
  if (tempFilters.carrierCodeList == null) {
    delete tempFilters['carrierCodeList'];
  }
  this.loadPage = (...config): Observable<SearchObjectResult<MasterData>> => {
    this.loader.startLoad();
    const mConfig = {
      page: config[0] - 1,
      pageSize: config[1],
      sortColumn: config[2],
      direction: config[3],
      countryCode:  this.countryCode,
      filters: tempFilters
    };
    this.loader.stopLoad();
    return this.dfManagementService.search(mConfig, assets);
  }
}

getMasterData() {
    this.isFetchButtonDisabled = false;
    this.isEditButtonDisabled = false;
    this.isButtonDisabled = false;
    this.assetContent = '';
}

 dfMasterData() {
  this.loader.startLoad();
  const formArray = this.dedicatedFleetMasterDataForm.controls[
    'amount'
  ] as FormArray;
  const chargesFormArray = formArray.getRawValue();
   const body = {
      id: this.editMasterData['id'],
      country_code: this.editMasterData['countryCode'],
      carrier_code: this.editMasterData['carrierCode'],
      asset_id: this.editMasterData['assetId'] ,
      asset_type: this.editMasterData['assetType'],
      status:  this.editMasterData['status'],
      contract_start_date: moment(this.dedicatedFleetMasterDataForm.value.contractStartDate).format('YYYY-MM-DDTHH:mm:ss.000+0000') ,
      contract_end_date: moment(this.dedicatedFleetMasterDataForm.value.contractEndDate).format('YYYY-MM-DDTHH:mm:ss.000+0000'),
      distance_travel: this.dedicatedFleetMasterDataForm.value.dfDistance ? this.dedicatedFleetMasterDataForm.value.dfDistance : null,
      distance_unit: this.editMasterData['distanceUnit'],
      charge_type: this.editMasterData['chargeType'],
      order_type: this.editMasterData['orderType'],
      rent_charges:  this.dedicatedFleetMasterDataForm.value.contractedTruckRentCharges ?
                    this.dedicatedFleetMasterDataForm.value.contractedTruckRentCharges : null,
      labour_charges: this.editMasterData['labourCharges'],
      fuel_charges: this.editMasterData['fuelCharges'],
      toll_charges: this.editMasterData['tollCharges'],
      other_charges: this.editMasterData['otherCharges'],
      extra_distance_charges: this.editMasterData['extraDistanceCharges'],
      total_charges: this.editMasterData['totalCharges'],
      currency: this.editMasterData['currency'],
      created_by: this.editMasterData['createdBy'] ,
      updated_by: this.editMasterData['updatedBy'],
      created_date: this.editMasterData['createdDate'] ,
      updated_date: this.editMasterData['updatedDate'] ,
      fixed_charge_frequency: this.editMasterData['fixedChargeFrequency'],
      charges: this.editMasterData['charges'],
      assetCharges: this.editMasterData['assetCharges'] && !this.editMasterData['assetCharges'].length ?
                    this.editMasterData['assetCharges'] : chargesFormArray
  }

  this.dfManagementService.addAssetCharge(body)
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe((succeed: MasterData) => {
        if (succeed['status_code'] === '1') {
          this.isVisible = false;
          this.applyForm('fleetManagement');
          this.resetDfMasterData();
            setTimeout(() => {
          this.isPopupModel = true;
        }, 500);
        }
        if (succeed['error_code'] === '-10') {
          this.isVisible = true;
          this.toastr.error(succeed['error_message']);
        }
      }, (error: HttpErrorResponse) => {
        this.toastr.error(error.error.message || this.translate.instant('df-management.table.error-post-data'));
      });
  }

  confirmData() {
    this.isPopupModel = false;
  }

  resetDfMasterData() {
  this.dedicatedFleetMasterDataForm.controls['contractStartDate'].reset();
  this.dedicatedFleetMasterDataForm.controls['contractEndDate'].reset();
  this.dedicatedFleetMasterDataForm.controls['dfDistance'].reset();
  this.dedicatedFleetMasterDataForm.controls['amount'].reset();
  this.dedicatedFleetMasterDataForm.controls['contractedTruckRentCharges'].reset();
  this.dateErrorMsg = false;
}

dfRemoveData() {
  this.loader.startLoad();
  this.dfManagementService.deleteByAssetChargeId(this.editMasterData['id'])
  .pipe(finalize(() => this.loader.stopLoad()))
  .subscribe(() => {
    this.isVisible = false;
   this.applyForm('fleetManagement');
  }, (error: HttpErrorResponse) => {
    this.toastr.error(error['error_message'] || this.translate.instant('df-management.table.error-remove-data'));
  });
}

uploadMasterDataFile(csvFile: File) {
  this.loader.startLoad();
    this.dfManagementService.uploadAllMasterData(csvFile, this.countryCode)
      .pipe(finalize(() => {
        this.loader.stopLoad();
      }))
      .subscribe(result => {
        this.failedReport = result.failedImportReportByteStream;
        if (result.status === 'FAILED') {
          this.toastr.error(result.reason);
          this.isPopupErrorModel = true;
        } else {
          this.toastr.success(this.translate.instant('df-management.form.file.file-upload-success-message'));
        }
      }, (e: HttpErrorResponse) => {
        console.error(e);
        this.toastr.error(e.error.message || this.translate.instant('df-management.form.file.default'));
      });
}




downloadMasterData() {
  this.loader.startLoad();
  this.dfManagementService.downloadAllMasterData(this.countryCode).
  subscribe(
    (data: Blob) => {
      this.triggerFileDownload(data, this.countryCode + '-import-contracts-template.xlsx');
      this.isPopupDownloadModel = true;
    },
    error => {
      console.error('Error downloading file:', error);
    }
  );
}

triggerFileDownload(data: Blob, fileName: string): void {
  const blob = new Blob([data], { type: 'application/octet-stream' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  this.loader.stopLoad();
}

downloadFailedReport () {
  const blob = this.blob.base64ToBlob(this.failedReport, 'application/octet-stream');
  const a = document.createElement('a');
  document.body.appendChild(a);
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = String(this.countryCode + '-failed-import-contracts-detailed-report.xlsx');
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
}

confirmDownload() {
  this.isPopupDownloadModel = false;
}
downloadButton() {
  this.isPopupErrorModel = false;
  this.downloadFailedReport();
  this.isDownReportSuccessPopupModel = true;
}

confirmDownloadReportButton () {
  this.isDownReportSuccessPopupModel = false;
}

/** select all drop down values based on select all check box in carrier Id dropdown */
selectAllForDropdownItems(items: any[]) {
  // tslint:disable-next-line:no-shadowed-variable
  const allSelect = items => {
    items.forEach(element => {
      element['selectedAllGroup'] = 'selectedAllGroup';
    });
  };
  allSelect(items);
}

openPopup(): void {
  this.notificationService.open();
}
}
